import React from 'react';
import { abbreviateNumber } from '@pascal/pascal-core';
import { defineChipColor } from '../../helpers/chipColor';
import { ODD_BY_BET_TYPE } from '../../enums/betTypesEnum';

export function SideBetsInfo({ t, chip, betType, quickBets, name, activeFreeBet }) {
  return (
    <div className='pair-block-items'>
      <span className='pair-word'>{t(name)}</span>
      <p className='pair-info'>{t('PAIR')}</p>
      {chip ? (
        <div className='pair-block-chips-wrp'>
          <div
            className={`pgc-bet-chip ${
              activeFreeBet.id ? 'free-chip' : defineChipColor(chip, quickBets)
            } ${abbreviateNumber(chip).toString().length > 3 ? 'large' : ''}`}
          >
            <div className='pgc-chip-number'>
              <span className='pgc-chip-number-text'>{abbreviateNumber(chip)}</span>
            </div>
          </div>
        </div>
      ) : null}
      <span className='pair-number'>{ODD_BY_BET_TYPE[betType]}</span>
      {/* <span className='pair-number'>456</span> */}
    </div>
  );
}
